module.exports = __webpack_public_path__ + "static/media/cow.52ed78ea.png";